module.exports = __webpack_public_path__ + "img/344.5b4d2966.gif";